import styled from 'styled-components'
import { theme } from '../../../../styles/_variables'


export const Label = styled.h4`
  font-weight: 700;
  font-size: ${theme.fonts.size.subTitle};
  margin: 0px 16px 0px 0px;
  color: ${theme.color.primaryColor};
`

export default Label
